module.exports = __webpack_public_path__ + "img/45.8f81e2fa.jpg";